import { tempID } from "@wx/lib-state";
import { getAreaId, getSortedCards } from "../../helpers";
import moveCard from "./move";
export default function (store, ev) {
    const card = ev.card || {};
    const id = ev.id || card.id || tempID();
    const state = store.getState();
    const columnKey = state.columnKey;
    const rowKey = state.rowKey;
    const rowId = ev.rowId || (rowKey && card[rowKey]) || state.rows[0].id;
    if (rowId && !ev.rowId)
        ev.rowId = rowId;
    const columnId = ev.columnId || card[columnKey] || state.columns[0].id;
    if (state.areasMeta[getAreaId(columnId, rowId)].noFreeSpace) {
        return false;
    }
    const cardObj = {
        [columnKey]: columnId,
        id,
        ...card,
    };
    if (rowKey) {
        cardObj[rowKey] = rowId;
    }
    let cards = state.cards;
    cards.push(cardObj);
    if (state.sort) {
        cards = getSortedCards({ ...state, cards }, store.sortRule);
    }
    store.setState({ cards });
    if (ev.before) {
        moveCard(store, { ...ev, id });
    }
    if (ev.select !== false) {
        store.in.exec("select-card", { id });
    }
    ev.card = cardObj;
    ev.id = id;
    return () => {
        store.in.exec("delete-card", { id, $meta: { skipHistory: true } });
    };
}
//# sourceMappingURL=add.js.map